import {ELanguage} from 'src/constants';
import {TTenant} from 'src/containers/User/definitions';

import {ENotificationLevel, ENotificationStatus, ESystemNotificationEntityType} from './model';
import {
  ESystemNewsType,
  TBusinessArticleNews,
  TBusinessBlogData,
  TBusinessCaseNews,
} from './model/systemNews';

const makeBusinessArticleNews = (meta: TBusinessBlogData): TBusinessArticleNews => ({
  type: ESystemNewsType.BusinessArticle,
  entityType: ESystemNotificationEntityType.NEWS,
  id: meta.url,
  status: ENotificationStatus.UNREAD,
  level: ENotificationLevel.WARNING,
  occurredAt: '',
  meta,
});

const makeBusinessCaseNews = (meta: TBusinessBlogData): TBusinessCaseNews => ({
  type: ESystemNewsType.BusinessCase,
  entityType: ESystemNotificationEntityType.NEWS,
  id: meta.url,
  status: ENotificationStatus.UNREAD,
  level: ENotificationLevel.WARNING,
  occurredAt: '',
  meta,
});

const isEnLanguage = (language: string) => language === ELanguage.en;

const businessArticlesNews = (language: string) =>
  [
    {
      url: 'https://edna.ru/news/novaya-tarifikacziya-whatsapp-chto-stanet-platnym-s-1-oktyabrya-2026-goda/',
      title: isEnLanguage(language)
        ? 'WhatsApp pricing changes on October 1: find out which messages will become chargeable'
        : 'WhatsApp меняет тарификацию с 1 октября: рассказываем, какие сообщения станут платными',
    },
    {
      url: 'https://app.edna.ru/company/profile/payment/replenishment',
      title:
        'Не надо отслеживать дату очередного платежа, ведь мы запустили оплату картами! Кликай сюда, чтобы подключить карту.',
      guard: (tenant: TTenant) => !!tenant.needAgreementConfirmation,
    },
    {
      url: 'https://t.me/companyedna/113',
      title:
        'Как снизить отписки, блокировки и увеличить конверсию? Сохранили для вас запись вебинара и пошаговый гайд по настройке Сценариев!',
    },
    {
      url: 'https://edna.ru/news/edna-pulse-webinar-01-07',
      title:
        'edna Pulse Сценарии: конструктор чат-ботов и автоматизированные рассылки в одном решении - приглашаем на вебинар 1 июля в 15:00 (МСК)',
    },
    {
      url: 'https://edna.ru/news/edna-webinar-21-05/?utm_source=organic&utm_medium=pulse',
      title:
        'Новая тарификация WhatsApp и последние обновления edna Pulse – приглашаем на вебинар 21 мая в 11:00 по Москве',
    },
    {
      url: 'https://edna.ru/news/dlya-chego-nuzhna-integracziya-whatsapp-v-bitriks24/',
      title: 'Для чего нужна интеграция WhatsApp в Битрикс24?',
    },
    {
      url: 'https://edna.ru/news/triggernye-rassylki-whatsapp/',
      title: 'Триггерные рассылки в WhatsApp — топ эффективных сценариев',
    },
    {
      url: 'https://edna.ru/news/kak-podgotovit-rassylku-na-23-fevralya-i-8-marta-chto-zhdut-klienty-ot-brendov/',
      title: 'Как подготовить рассылку на 23 февраля и 8 марта: что ждут клиенты от брендов?',
    },
    {
      url: 'https://edna.ru/news/otpiska-bez-poter-tri-varianta-kak-otpisat-klienta-ot-rassylki-v-whatsapp-i-sohranit-ego-loyalnost/',
      title:
        'Отписка без потерь: три варианта, как отписать клиента от рассылки в WhatsApp и сохранить его лояльность',
    },
    {
      url: 'https://edna.ru/news/whatsapp-rassylki-pered-prazdnikami-kak-povysit-prodazhi-a-ne-risk-blokirovki/',
      title: 'WhatsApp-рассылки перед праздниками: как повысить продажи, а не риск блокировки',
    },
    {
      url: 'https://edna.ru/news/god-zelenogo-messendzhera-podvodim-itogi-s-whatsapp-business-api/',
      title: 'Год зеленого мессенджера: подводим итоги с WhatsApp Business API',
    },
    {
      url: 'https://edna.ru/news/chat-center-remote/',
      title: 'Удаленная работа в контактных центрах: решения для эффективности и безопасности',
    },
    {
      url: 'https://edna.ru/news/modul-templates-sms/',
      title:
        'Компания edna запустила модуль Templates: регистрация шаблонов SMS стала быстрее и удобнее',
    },
    {
      url: 'https://edna.ru/news/edna-bitrix-conf-2024/',
      title: 'edna приняла участие в партнерской конференции Битрикс24 «Гравитация»',
    },
    {
      url: 'https://edna.ru/news/ai-sufler-v-chat-czentre-edna-novyj-instrument-dlya-bystrogo-i-kachestvennogo-konsultirovaniya-klientov/',
      title:
        'AI-суфлер в чат-центре edna — новый инструмент для быстрого и качественного консультирования клиентов',
    },
    {
      url: 'https://edna.ru/news/avtorizaczionnye-soobshheniya-v-viber-nadezhnoe-reshenie-dlya-otpravki-otp-s-edna/',
      title: 'Авторизационные сообщения в Viber – надежное решение для отправки OTP с edna',
    },
    {
      url: 'https://edna.ru/news/kak-postroit-silnuyu-it-komandu/',
      title: 'Как построить сильную ИТ-команду?',
    },
    {
      url: 'https://edna.ru/news/biznes-uvedomleniya-vk-notify-stali-dostupny-v-odnoj-papke-dlya-chatov-vkontakte/',
      title: 'Бизнес-уведомления VK Notify стали доступны в одной папке для чатов ВКонтакте',
    },
    {
      url: 'https://edna.ru/news/v-whatsapp-poyavilas-vozmozhnost-ustanavlivat-ttl-srok-zhizni-soobshheniya/',
      title: 'В WhatsApp появилась возможность устанавливать TTL — срок жизни сообщения',
    },
    {
      url: 'https://edna.ru/news/edna-i-just-ai-priglashayut-na-vebinar-ai-sufler-nadezhnyj-pomoshhnik-operatora-chat-czentra/',
      title:
        'edna и Just AI приглашают на вебинар «AI-суфлер — надежный помощник оператора чат-центра»',
    },
    {
      url: 'https://edna.ru/news/kak-zakryt-godovye-plany-prodazh-s-whatsapp-business-api/',
      title: 'Как закрыть годовые планы продаж с WhatsApp Business API',
    },
    {
      url: 'https://edna.ru/news/glavnye-trendy-razvitiya-czifrovyh-kontaktnyh-czentrov-v-2024-godu/',
      title: 'Главные тренды развития цифровых контактных центров в 2024 году',
    },
    {
      url: 'https://edna.ru/news/chernaya-pyatnicza-i-novyj-god-c-whatsapp-vozmite-maksimum-ot-rassylok-v-messendzhere/',
      title: '«Черная пятница» и Новый год c WhatsApp: возьмите максимум от рассылок в мессенджере',
    },
    {
      url: 'https://edna.ru/news/verifikacziya-polzovatelej-cherez-telegram-omnikanalnoe-reshenie-ot-edna/',
      title: 'Верификация пользователей через Telegram: омниканальное решение от edna',
    },
    {
      url: 'https://edna.ru/news/top-prichin-po-kotorym-ne-otpravlyaetsya-shablon-rassylki-v-whatsapp/',
      title: 'Топ причин, по которым не отправляется шаблон рассылки в WhatsApp',
    },
    {
      url: 'https://edna.ru/news/summarizacziya-teksta-v-chat-czentre-edna-ekonomte-vremya-operatorov-i-supervajzerov/',
      title: 'Суммаризация текста в чат-центре edna: экономьте время операторов и супервайзеров',
    },
    {
      url: 'https://edna.ru/news/kak-vyrastit-sales-menedzhera-za-kotorym-vse-ohotyatsya/',
      title: 'Как вырастить sales-менеджера, за которым все охотятся?',
    },
    {
      url: 'https://edna.ru/news/integracziya-chat-czentra-edna-s-avito-kachestvennaya-obrabotka-obrashhenij-klientov-v-klassifajde/',
      title:
        'Интеграция чат-центра edna с Авито: качественная обработка обращений клиентов в классифайде',
    },
    {
      url: 'https://edna.ru/news/gajd-po-oformleniyu-rassylok-v-whatsapp-kak-sozdavat-prodayushhie-soobshheniya/',
      title: 'Гайд по оформлению рассылок в WhatsApp: как создавать продающие сообщения',
    },
    {
      url: 'https://edna.ru/news/karta-populyarnosti-messendzherov-v-regionah-rf/',
      title: 'Карта популярности мессенджеров в регионах РФ',
    },
  ].map(makeBusinessArticleNews);

const businessCasesNews = [
  {
    url: 'https://edna.ru/cases/case-hypermarketmebel/',
    title:
      'Первый Гипермаркет Мебели: как WhatsApp Business API помогает увеличивать продажи на сайте',
  },
  {
    url: 'https://edna.ru/cases/fg-finam-kak-vyrastit-populyarnyj-chat/',
    title: 'ФГ «Финам»: как вырастить популярный чат',
  },
  {
    url: 'https://edna.ru/cases/ne-mogu-govorit-pokupayu-bitkoiny-kak-skillbox-obrabatyvaet-zayavki-na-obuchenie-s-pomoshhyu-whatsapp/',
    title:
      '«Не могу говорить – покупаю биткоины»: как Skillbox обрабатывает заявки на обучение с помощью WhatsApp',
  },
  {
    url: 'https://edna.ru/cases/russiadiscovery-kak-integracziya-whatsapp-s-bitriks24-ot-edna-pomogaet-puteshestvovat-po-rossii/',
    title:
      'RussiaDiscovery: как интеграция WhatsApp с «Битрикс24» от edna помогает путешествовать по России',
  },
  {
    url: 'https://edna.ru/cases/emc-wa/',
    title: 'ЕМС: как сеть клиник подняла продажи на 30 % c WhatsApp Business API',
  },
  {
    url: 'https://edna.ru/cases/fitstars-kak-integracziya-whatsapp-s-carrot-quest-ot-edna-pomogaet-rabotat-so-sczenariem-nezavershennaya-oplata/',
    title:
      'FitStars: как интеграция WhatsApp с Carrot quest от edna помогает работать со сценарием «Незавершенная оплата»',
  },
  {
    url: 'https://edna.ru/cases/reaktivacziya-klientov-i-broshennaya-korzina-kakie-sczenarii-marketingovyh-rassylok-v-whatsapp-ispolzuet-synergetic/',
    title:
      'Реактивация клиентов и «брошенная корзина»: какие сценарии маркетинговых рассылок в WhatsApp использует SYNERGETIC',
  },
  {
    url: 'https://edna.ru/cases/cofix-edna/',
    title:
      'Кейс Cofix: как чат-бот в WhatsApp помогает трем рекрутерам закрывать все массовые вакансии сети кофеен',
  },
  {
    url: 'https://edna.ru/cases/kejs-k-31-kak-s-pomoshhyu-whatsapp-set-klinik-sokratila-vremya-registraczii-na-priem-i-povysila-vozvrashhaemost-klientov/',
    title:
      'Кейс «К+31»: как с помощью WhatsApp сеть клиник сократила время регистрации на прием и повысила возвращаемость клиентов',
  },
  {
    url: 'https://edna.ru/cases/ukids-kak-onlajn-akademiya-ekonomit-vremya-roditelej-i-planiruet-raspisanie-s-pomoshhyu-whatsapp/',
    title:
      'Ukids: как онлайн-академия экономит время родителей и планирует расписание с помощью WhatsApp',
  },
  {
    url: 'https://edna.ru/cases/insales-kak-povysit-konversiyu-v-aktivacziyu-novyh-klientov-s-pomoshhyu-welcome-czepochkiv-whatsapp/',
    title:
      'inSales: как повысить конверсию в активацию новых клиентов с помощью welcome-цепочки в WhatsApp',
  },
  {
    url: 'https://edna.ru/cases/partnerskij-kejs-edna-i-keep-calm-vidzhet-whatsapp-business-api-v-amocrm-dlya-besshovnoj-kommunikaczii-biznesov-s-klientami/',
    title:
      'Партнерский кейс edna и KEEP CALM: виджет WhatsApp Business API в amoCRM для для бесшовной коммуникации бизнесов с клиентами',
  },
  {
    url: 'https://edna.ru/cases/gk-pioner-kak-integracziya-whatsapp-c-microsoft-teams-i-crm-pozvolila-isklyuchit-riski-poteri-dannyh-i-sokratit-sroki-provedeniya-sdelki/',
    title:
      'ГК «Пионер»: как интеграция WhatsApp c Microsoft Teams и CRM позволила исключить риски потери данных и сократить сроки проведения сделки',
  },
  {
    url: 'https://edna.ru/cases/avilon/',
    title: '«АВИЛОН»: как за 2 месяца WhatsApp стал самым конверсионным каналом',
  },
  {
    url: 'https://edna.ru/cases/hadasa/',
    title: 'ГК «Медскан»: как в цифровых каналах закрывать потребность пациента за 5 минут',
  },
  {
    url: 'https://edna.ru/cases/dodo-pizza/',
    title: '«Додо Пицца»: как сделать чат в приложении, которым довольны 9 из 10 пользователей',
  },
  {
    url: 'https://edna.ru/cases/vprok-perekrestok/',
    title:
      'Отвечать за 30 секунд и помогать закупаться впрок: как edna подключила цифровые каналы для онлайн-гипермаркета «Vprok.ru Перекресток»',
  },
  {
    url: 'https://edna.ru/cases/emc/',
    title:
      'Цифровая трансформация EMC. Как клиника получила +12 % к плану продаж в первый месяц после запуска WhatsApp и внедрения чат-центра edna',
  },
].map(makeBusinessCaseNews);

export {businessCasesNews, businessArticlesNews};
